// src/js/modules/klaviyo-popup.js
var cookieName = "sc_popup_timestamp";
var expiryTime = KLAVIYO_EXPIRY_TIME * 60 * 60 * 1e3;
var desktopFormID = KLAVIYO_FORM_ID_DESKTOP;
var mobileFormID = KLAVIYO_FORM_ID_MOBILE;
var popupDelay = KLAVIYO_POPUP_DELAY * 1e3;
var currentTime = Date.now();
if (shouldShowPopup()) {
  setPopupTimeout();
}
function shouldShowPopup() {
  const popupExpiry = localStorage.getItem(cookieName);
  return currentTime > popupExpiry && desktopFormID != "" && mobileFormID != "";
}
function setPopupTimeout() {
  setTimeout(maybeOpenPopup, popupDelay);
}
function maybeOpenPopup() {
  if (isActiveModal()) {
    setPopupTimeout();
  } else {
    openPopup();
    setPopupCookie();
  }
}
function isActiveModal() {
  const classNames = [
    "hide-scrollbar",
    "has-active-modal"
  ];
  let bodyHasClass = false;
  classNames.forEach((className) => {
    if (document.querySelector("body").classList.contains(className)) {
      bodyHasClass = true;
      return;
    }
  });
  return bodyHasClass;
}
function openPopup() {
  const formID = getFormID();
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(["openForm", formID]);
}
function getFormID() {
  if (navigator.maxTouchPoints > 0 || window.innerWidth < 750) {
    return mobileFormID;
  }
  return desktopFormID;
}
function setPopupCookie() {
  const expiryDate = /* @__PURE__ */ new Date();
  const expiryTimestamp = expiryDate.getTime() + expiryTime;
  localStorage.setItem(cookieName, expiryTimestamp);
}
